import { LinearProgress } from '@material-ui/core';
import * as React from 'react';
import styles from './FloatingLinearProgress.module.css';
export function FloatingLinearProgress(props) {
    if (props.display)
        return (React.createElement("div", { className: styles.progressBarContainer },
            React.createElement(LinearProgress, null)));
    return null;
}
